import { useMemo, useEffect } from 'react';
import recentSearches from './recent-searches';
var useRecentSearches = _ref => {
  var onLoadedRecentSearches = _ref.onLoadedRecentSearches,
    recentSearchKey = _ref.recentSearchKey;
  var recent = useMemo(() => {
    if (!recentSearchKey) {
      return {
        recentItems: [],
        saveRecentSearch: () => {}
      };
    }
    var _recentSearches = recentSearches(recentSearchKey),
      saveRecentSearch = _recentSearches.saveRecentSearch,
      getRecentSearches = _recentSearches.getRecentSearches;
    return {
      recentItems: getRecentSearches(),
      saveRecentSearch
    };
  }, [recentSearchKey]);
  useEffect(() => {
    if (recent.recentItems) {
      onLoadedRecentSearches(recent.recentItems);
    }
  }, [recent, onLoadedRecentSearches]);
  return recent;
};
export default useRecentSearches;